<div *ngIf="!isLoading" [formGroup]="form" class="custom-field-form">
    <div *ngIf="customFields.length>0" class="header">
        <h3 class="title">Custom Field Form <span>{{ isRequired ? 'Required' : 'Optional' }}</span></h3>
    </div>
    <ng-container formArrayName="customFieldsArr">
        <ng-container *ngFor="let formArr of getFormsArray(form.get('customFieldsArr')) ;  let i = index">
            <div [formGroupName]="i" class="form-group">
              <div>
                <label for="" class="form-label" [ngClass]="{'required': isRequired}">
                  {{formArr?.controls['fieldName']?.value}}
                  <span *ngIf="formArr?.controls['fieldDesc']?.value">( {{formArr?.controls['fieldDesc']?.value}} )</span>
                </label>
                <app-info-icon
                  *ngIf="formArr?.controls['help_text_active']?.value && formArr?.controls['help_text']?.value"
                  [tooltip]="formArr?.controls['help_text']?.value">
                </app-info-icon>
              </div>
              <input type="text" [formControlName]="'content'" class="form-control" autocomplete="off">

            </div>
        </ng-container>
    </ng-container>
</div>
<!-- loading -->
<div *ngIf="isLoading" class="custom-field-form">
    <div class="header">
        <h3 class="title">Custom Field Form <span>(Optional)</span></h3>
    </div>
    <div class="form-group isLoading">
        <ngx-skeleton-loader appearance="line" [theme]="{ 
            'border-radius': '5px',
            height: '60px',
            'width':'100%'
          }"></ngx-skeleton-loader>
    </div>
    <div class="form-group isLoading">
        <ngx-skeleton-loader appearance="line" [theme]="{ 
            'border-radius': '5px',
            height: '60px',
            'width':'100%'
        }"></ngx-skeleton-loader>
    </div>
</div>
